export default "__VITE_ASSET__TXGrM6U2__"